import React, { useEffect, useRef, useState } from 'react';
import { LazyImgContainer } from '../../styles/layOutStyles';

import { PROJECT_IMG } from '../../constants/index';

const LazyImages = ({ src, alt, style, type, imgStyle }) => {
  const imgRef = useRef('');
  const [_src, setSrc] = useState('');

  useEffect(() => {
    if (imgRef?.current) {
      imgRef?.current?.classList.remove('active');
      imgRef?.current?.classList.add('lazy');
    }

    setSrc(src);
  }, [src]);

  useEffect(() => {
    const imgs = document.querySelectorAll('.lazy');

    const observerCallback = (entries, observer) => {
      entries.forEach(({ isIntersecting, target }) => {
        if (isIntersecting) {
          if (target.dataset?.src) {
            target.src = target.dataset?.src;
          } else {
            let noImg;

            noImg = `${PROJECT_IMG}/noImg.png`;

            target.src = noImg;
          }
          target.classList.remove('lazy');
          target.classList.add('active');
          observer.unobserve(target);
        }
      });
    };

    const io = new IntersectionObserver(observerCallback);

    imgs.forEach(img => {
      io.observe(img);
    });
  }, [_src, type]);

  return (
    <LazyImgContainer style={style}>
      <div style={{ left: 0, bottom: 0 }} />
      {_src && <img ref={imgRef} className='lazy_images lazy' data-src={_src} style={imgStyle} alt={alt} />}
    </LazyImgContainer>
  );
};

export default LazyImages;
